 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCVI from '@/components/Text/cvi'
 import LOVE_1 from '@/components/love_1'
 import TEXTTP from '@/components/Text/tp'
 import TEXTCOP from '@/components/Text/cop'
 import TEXTDED from '@/components/Text/ded'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTFRW from '@/components/Text/frw'
 import TEXTITR from '@/components/Text/itr'
 import TEXTC01 from '@/components/Text/c01'
 import TEXTC02 from '@/components/Text/c02'
 import TEXTC03 from '@/components/Text/c03'
 import TEXTC04 from '@/components/Text/c04'
 import TEXTC05 from '@/components/Text/c05'
 import TEXTC06 from '@/components/Text/c06'
 import TEXTC07 from '@/components/Text/c07'
 import LOVE_2 from '@/components/love_2'
 import TEXTBM from '@/components/Text/bm'
 import TEXTBM1 from '@/components/Text/bm1'
 import TEXTBM2 from '@/components/Text/bm2'
 import TEXTBM3 from '@/components/Text/bm3'
 import TEXTRES from '@/components/Text/res'
 import TEXTATA from '@/components/Text/ata'
 import TEXTACK from '@/components/Text/ack'
 import TEXTCRD from '@/components/Text/crd'
 import TEXTADC from '@/components/Text/adc'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/frw",
 			"name" : "Text/frw",
 			"component" : TEXTFRW
 		},
 		{
 			"path" : "/Text/itr",
 			"name" : "Text/itr",
 			"component" : TEXTITR
 		},
 		{
 			"path" : "/Text/c01",
 			"name" : "Text/c01",
 			"component" : TEXTC01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js